import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Route, Routes, useNavigate } from "react-router-dom";
import maxProfileFallBack from "../../assets/images/Max-profile-fallback.svg";
import Header from "../../front-end-global-components/components/Header/Header";
import {
  confirmAbdmLogin,
  setAuthModes,
  setTransactionId
} from "../../redux/patients/actions";
import { isValidArray } from "../../utils/validators";
import TermsAndConditionModal from "../../components/TermsAndConditionModal/TermsAndConditionModal";
import CheckBox from "../../front-end-global-components/components/CheckBox/CheckBox";
import { setErrorStatus } from "../../redux/status/actions";

function ABDMList(props) {
  const [authMode, setAuthMode] = useState(null);
  const [healthIdData, setHealthIdData] = useState(null);
  const [agreeTo, setAgreeTo] = useState(null);
  const navigate = useNavigate();
  // Aadhaar e-KYC already captures consent, so the agreement is skipped there
  const isAadhaarFlow = authMode === "AADHAAR Number";

  useEffect(() => {
    if (!props.patients?.transaction?.id) {
      navigate("/abdm/login", { replace: true });
    }
    // eslint-disable-next-line
  }, [props.patients?.transaction?.id]);

  useEffect(() => {
    const data = new URLSearchParams(window.location.search)?.get("authMode");
    if (data) {
      setAuthMode(data);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (
      isValidArray(props.patients.usedHealthId) ||
      isValidArray(props.patients.unusedHealthId)
    ) {
      if (
        isValidArray(props.patients.usedHealthId) &&
        isValidArray(props.patients.unusedHealthId)
      ) {
        return setHealthIdData([
          ...props.patients.usedHealthId,
          ...props.patients.unusedHealthId
        ]);
      } else if (isValidArray(props.patients.usedHealthId)) {
        return setHealthIdData([...props.patients.usedHealthId]);
      } else if (isValidArray(props.patients.unusedHealthId)) {
        return setHealthIdData([...props.patients.unusedHealthId]);
      }
    }
  }, [props.patients.usedHealthId, props.patients.unusedHealthId]);

  return (
    <>
      <Header
        title="ABDM List"
        backButtonOnClick={() => {
          navigate("/abdm/login", { replace: true });
          if (props.patients?.transaction?.id !== null) {
            setTransactionId(null);
            setAuthModes(null);
          }
        }}
        hideSupport={true}
        incident={props.app.featureFlags?.incident?.patients}
        incidentOnClick={() => {
          navigate("/incidents");
        }}
      />
      <section className="remaining-body-height max-width-588px margin-horizontal-auto overflow-y-auto inherit-parent-width ">
        <div className="padding-left-larger padding-right-larger inherit-parent-height flex-direction-column flex-justify-content-space-between">
          <div className="inherit-parent-width display-flex flex-justify-content-center padding-top-larger">
            <img src={maxProfileFallBack} alt="" height={100} width={"auto"} />
          </div>
          <div className="text-align-center letter-spacing-large font-family-gilroy-regular font-size-medium font-color-secondary padding-top-larger padding-bottom-large">
            Choose an existing ABHA address for login or create a new ABHA
            address.
          </div>
          <div className="text-align-center letter-spacing-large font-family-gilroy-regular font-size-small font-color-secondary padding-bottom-large">
            EXISTING ABHA ADDRESS ARE LISTED BELOW
          </div>
          {isValidArray(healthIdData) ? (
            <div className="adaptive-height-healthId-list overflow-scroll hide-scroll-bar">
              {healthIdData.map((data, index) => (
                <div
                  key={index}
                  onClick={() => {
                    confirmAbdmLogin(
                      data.healthId,
                      props.auth?.data?.transactionId,
                      ["MOBILE_OTP", "EMAIL_OTP"].includes(
                        props.auth?.data?.authMode
                      )
                        ? props.auth?.data?.authMode
                        : "ABHANUMBER",
                      data.patientId,
                      props.auth?.data?.abdmToken,
                      navigate,
                      true
                    );
                  }}
                  className="cursor-pointer display-flex flex-justify-content-space-between margin-top-default font-color-secondary font-family-gilroy-medium"
                >
                  <div>
                    <div className="font-size-medium padding-top-large">
                      {data.healthId}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className=" font-color-secondary inherit-parent-height flex-align-items-center flex-justify-content-center">
              There is no Existing ABHA Address
            </div>
          )}

          <div>
            <div className="flex-center-children-vertically margin-vertical-large ">
              <hr
                style={{ width: "100%" }}
                className="display-inline-block border-color-secondary-lite border-top-left-right-none flex-basis-1 "
              />
              <span className=" margin-horizontal-default display-inline-block font-color-tertiary font-size-small">
                OR
              </span>
              <hr
                style={{ width: "100%" }}
                className="display-inline-block border-color-secondary-lite border-top-left-right-none flex-basis-1 "
              />
            </div>

            <Routes>
              <Route
                path="terms"
                element={
                  <TermsAndConditionModal
                    isCreationTerms={true}
                    onClose={() => {
                      navigate("");
                    }}
                  />
                }
              />
            </Routes>

            {!isAadhaarFlow && (
              <div className="inherit-parent-width display-flex padding-top-large text-align-left font-size-small margin-top-small">
                <CheckBox
                  name="agreeTo"
                  checked={agreeTo}
                  onChange={(event) => {
                    setAgreeTo(event.target.checked);
                  }}
                  label={
                    <div className="font-size-small">
                      I agree to voluntarily share my identity information with
                      Byepo Technologies to create my ABHA Address{" "}
                      {
                        <span
                          className="cursor-pointer padding-left-small font-family-RHD-regular font-color-primary"
                          onClick={() => {
                            navigate("terms");
                          }}
                        >
                          User Information Agreement
                        </span>
                      }
                    </div>
                  }
                />
              </div>
            )}

            <div className="inherit-parent-width padding-bottom-large">
              <div className="font-weight-normal font-family-gilroy-medium font-size-small font-color-secondary inherit-parent-width text-align-center">
                Still want to create a new ABHA address?
                <span
                  onClick={() => {
                    if (!isAadhaarFlow && !agreeTo) {
                      return setErrorStatus({
                        code: "custom",
                        message:
                          "Please agree to the User Information Agreement to proceed"
                      });
                    }
                    const mobile = new URLSearchParams(
                      window.location.search
                    )?.get("mobile");
                    if (mobile) {
                      navigate(
                        `/abdm/create/?authMode=${authMode}&mobile=${mobile.toString()}`
                      );
                    } else {
                      navigate(`/abdm/create/?authMode=${authMode}`);
                    }
                  }}
                  className="font-color-primary padding-left-small cursor-pointer"
                >
                  Create
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  abdm: state.abdm,
  patients: state.patients,
  app: state.app
});

export default connect(mapStateToProps)(ABDMList);
